import { useRef } from "react";

export const useComponentRefs = () => {

  // Ref to App component
  const appRef = useRef(null);

  // Ref to the content of routes (without navbar and sidebar)
  const routerRef = useRef(null);


  return { appRef, routerRef };
}